import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * QRCodeImage — renders a real QR code as a data URL image.
 * Falls back to a blank placeholder while generating.
 *
 * @param {string} value  - The URL or text to encode
 * @param {number} size   - Rendered size in px (default 160)
 * @param {string} [alt]
 */
export default function QRCodeImage({ value, size = 160, alt = 'QR code', style }) {
  const [dataUrl, setDataUrl] = useState('');

  useEffect(() => {
    if (!value) {
      setDataUrl('');
      return;
    }
    QRCode.toDataURL(value, {
      width: size * 2,
      margin: 2,
      color: { dark: '#0A0A0A', light: '#F5F5F0' },
      errorCorrectionLevel: 'M',
    })
      .then(setDataUrl)
      .catch(() => setDataUrl(''));
  }, [value, size]);

  if (!dataUrl) {
    return (
      <div
        style={{
          width: size,
          height: size,
          backgroundColor: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          ...style,
        }}
      />
    );
  }

  return (
    <img
      src={dataUrl}
      width={size}
      height={size}
      alt={alt}
      style={{ display: 'block', imageRendering: 'pixelated', ...style }}
    />
  );
}
